<!--收货地址-->
<template>
  <div class="ship-container" :style="'min-height:'+min_height+'px;'">
    <div class="ship-content">
      <div class="ship-title">
        <span class="SourceHanSansCN">收货地址</span>
        <el-link type="primary" :underline="false" @click="addShipAddress">新增地址</el-link>
      </div>
      <div class="ship-info" v-if="addressInfo.length>0">
        <div v-for="(address,index) of addressInfo">
          <div class="default-ship">
            <span class="name">{{ address.name }}</span>
            <span class="mobile">{{ parseStringToStar(address.mobile) }}</span>
            <span class="address">{{ address.provinceName }}{{ address.cityName }}{{ address.address }}</span>
            <i class="default-icon" v-if="address.def==1">默认</i>
            <el-link :underline="false" type="danger" @click="deleteShip(address.id)">删除</el-link>
            <el-link :underline="false" type="danger" style="margin-right: 20px;" @click="editShipAddress(address.id)">
              编辑
            </el-link>
            <el-link :underline="false" type="danger" style="margin-right: 20px;" v-if="address.def!=1"
                     @click="setDefault(address.id)">设为默认地址
            </el-link>
          </div>
        </div>
      </div>
      <div class="empty-content" v-else :style="'min-height:'+m_height+'px;'">
        <i class="iconfont icon-recommend"></i>
        <p class="text">没有收货地址</p>
      </div>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="45%" class="ship-dialog" :close-on-click-modal="false">
      <el-form :model="editData" status-icon :rules="rules" ref="shipForm" label-width="85px" class="shipForm" label-position="left" :hide-required-asterisk="true">
        <el-form-item label="收货人" prop="name">
          <el-input v-model="editData.name" clearable/>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input v-model="editData.mobile" clearable/>
        </el-form-item>
        <el-form-item label="省市区" prop="area">
          <el-select v-model="editData.province" placeholder="请选择" @change="changeProvince" filterable clearable>
            <el-option :label="item.name" :value="item.id" v-for="(item, index) in addressData"/>
          </el-select>
          <el-select v-model="editData.city" @change="changeUrban " placeholder="请选择" filterable clearable>
            <el-option :label="item.name" :value="item.id" v-for="(item, index) in cityArray"/>
          </el-select>
          <el-select v-model="editData.area" filterable placeholder="请选择" style="margin-right: 0px;" clearable>
            <el-option :label="item.name" :value="item.id" v-for="(item, index) in areaArray"/>
          </el-select>
        </el-form-item>
        <el-form-item label="详细地址" prop="address">
          <el-input v-model="editData.address" type="textarea" :autosize="{ minRows: 3}"/>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="danger" @click="saveRecommend">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Provincial from "@/static/marketCityList.json";
import {setUpAddressList, setUpAddressSave,setUpAddressDel} from '@/api/systemSetting'
export default {
  name: "shipAddress",
  data() {
    // 验证手机号
    let validatorPhone = function (rule, value, callback) {
      if (value === "")
        callback(new Error("手机号不能为空"));
      else if (!/^1\d{10}$/.test(value))
        callback(new Error("手机号格式错误"));
      else
        callback();
    }
    return {
      addressInfo: [],
      min_height: document.documentElement.clientHeight - 346,
      m_height: document.documentElement.clientHeight - 446,
      dialogVisible: false,
      editData: {
        id: 0,
        name: '',
        sex: 0,
        mobile: '',
        provinceName: '',
        cityName: '',
        province: 0,
        city: 0,
        area: 0,
        latitude: 0,
        longitude: 0,
        address: '',
        tag: 0,
        def: 0
      },
      dialogTitle: '新增地址',
      rules: {
        name: [
          {required: true, message: '请输入收货人', trigger: 'blur'},
          {min: 1,max: 10, message: '请勿输入特殊符号，最多10字', trigger: 'blur'}
        ],
        mobile: [
          { required: true, validator: validatorPhone, trigger: "blur" },
        ],
        area: [{ required: true, message: "请选择省市区", trigger: "blur" }],
        address: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
        ],
      },
      addressData:Provincial,
      cityArray:[],
      areaArray:[],
    }
  },
  methods: {
    /*手机号处理*/
    parseStringToStar(str) {
      let start = str.slice(0, 3)
      let end = str.slice(-4)
      return `${start}****${end}`
    },
    /*删除收货地址*/
    deleteShip(id) {
      let cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
      setUpAddressDel({
        id: id,
        uid: cid!=0 && cid!=undefined ? cid : 0
      }).then(res=>{
        if (res.code==200){
          this.$message.success('删除成功！')
          this.getAddressList();
        }else {
          this.$message.error('删除失败！');
        }
      })
    },
    /*设为默认地址*/
    setDefault(id) {
      let cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
      for (let ship of this.addressInfo) {
        if (id == ship.id){
          ship.def = 1;
          ship.uid=cid!=0 && cid!=undefined ? cid : 0,/*用户id*/
          setUpAddressSave(ship).then(res=>{
            if (res.code==200){
              this.$message.success('设置成功！');
              this.getAddressList();
            }else{
              this.$message.error('设置失败！');
            }
          })
        }
      }
    },
    /*编辑收获地址*/
    editShipAddress(id) {
      for (let address of this.addressInfo) {
        if (id == address.id) {
          this.editData = address;
          for (let address of this.addressData) {
            if (address.id === this.editData.province) {
              this.cityArray = address.children;
              for (let area of this.cityArray) {
                if (area.id === this.editData.city) {
                  this.areaArray = area.children;
                }
              }
            }
          }
          this.dialogTitle = '编辑地址';
          this.dialogVisible = true;
        }
      }
    },
    /*新建地址*/
    addShipAddress() {
      this.editData = {
        id: 0,
        name: '',
        sex: 0,
        mobile: '',
        provinceName: '',
        cityName: '',
        province: '',
        city: '',
        area: '',
        latitude: 0,
        longitude: 0,
        address: '',
        tag: 0,
        def: 0
      }
      this.dialogTitle = '新增地址';
      this.dialogVisible = true;
    },
    // 第一个地址选择框的值改变时
    changeProvince() {
      this.editData.city = null;
      this.editData.area = null;
      for (let address of this.addressData) {
        if (address.id === this.editData.province) {
          this.cityArray = address.children;
        }
      }
    },
    // 第二个地址选择框的值改变时
    changeUrban() {
      this.editData.area = null;
      for (let area of this.cityArray) {
        if (area.id === this.editData.city) {
          this.areaArray = area.children;
        }
      }
    },
    /*获取收货地址*/
    getAddressList(){
      let uid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
      setUpAddressList({uid:uid!=0 && uid!=undefined ? uid : 0}).then(res=>{
        if (res.code==200){
          this.addressInfo=res.content;
        }
      })
    },
    /*保存收货地址*/
    saveRecommend(){
      this.$refs.shipForm.validate((valid) => {
        if (valid) {
          let cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
          setUpAddressSave({
            uid:cid!=0 && cid!=undefined ? cid : 0,/*用户id*/
            address:this.editData.address,/*详细地址*/
            area:this.editData.area,/*区编码*/
            city:this.editData.city,/*市编码*/
            def:this.editData.def,/*默认收货地址（0：否，1：是）*/
            id:this.editData.id,/*新增传0*/
            latitude:0,/*纬度*/
            longitude:0,/*经度*/
            mobile:this.editData.mobile,/*手机号*/
            name:this.editData.name,/*姓名*/
            province:this.editData.province,/*省编码*/
            sex:this.editData.sex,/*0.未选择1.先生2.女士*/
            tag:this.editData.tag,/*0.未选择1.家2.公司3.学校*/
          }).then(res=>{
            if (res.code==200){
              this.$message.success(res.msg)
              this.dialogVisible = false;
              this.getAddressList();
            }else{
              this.$message.error(res.msg)
            }
          })
        } else {
          return false;
        }
      });
    }
  },
  mounted() {
    this.getAddressList();
  }
}
</script>
<style scoped>
.ship-dialog >>> .el-dialog__header {
  padding: 10px 20px 10px;
  border-bottom: 1px solid #EEEEEE;
}
.ship-dialog >>> .el-select{
  margin-right: 45px;
}
.ship-dialog >>> .el-form-item__content {
  justify-content: space-around;
  display: flex;
}
.ship-dialog >>> .el-input__inner{
  background-color: #F1F1F1;
  color: #333333;
}
.ship-dialog >>> .el-textarea__inner{
  background-color: #F1F1F1;
  color: #333333;
}
.ship-dialog >>> .el-input__inner ::placeholder {
  color: #999999;
}
.ship-dialog >>> input::-webkit-input-placeholder {
  color: #999999;
}
.ship-dialog >>> .dialog-footer .el-button--danger {
  color: #FFF;
  background-color: #FE273B;
  border-color: #FE273B;
}
.ship-dialog >>> .dialog-footer .el-button--danger:hover {
  color: #f56c6c;
  background: #fef0f0;
  border-color: #fbc4c4;
}
</style>
<style scoped lang="scss">
.ship-container {
  background: #ffffff;

  .ship-content {
    .ship-title {
      padding: 20px;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #F1F1F1;

      span {
        font-size: 16px;
        color: #333333;
        cursor: context-menu;
      }

      .el-link {
        color: #1637FF;
        font-size: 14px;
      }
    }

    .ship-info {
      padding: 20px 20px;

      .default-ship {
        font-size: 14px;
        color: #333333;
        padding: 20px;

        &:hover .el-link {
          display: block;
        }

        .name {
          padding-right: 10px;
        }

        .mobile {
          padding-right: 10px;
        }

        .address {
          padding-right: 10px;
        }

        .default-icon {
          font-size: 14px;
          font-style: normal;
          color: #FE273B;
          background: #FFD2D4;
          border-radius: 4px;
          padding: 5px 10px;
        }

        .el-link {
          display: none;
          color: #FE273B;
          font-size: 14px;
          float: right;
        }

        &:hover {
          background: #F1F1F1;
        }
      }
    }
    .empty-content{
      text-align: center;
      display: inline-grid;
      width: 100%;
      .icon-recommend{
        font-size: 48px;
        color: rgb(192, 196, 204);
        display: flex;
        justify-content: center;
        align-items: self-end;
      }
      .text{
        color: rgb(192, 196, 204);
        font-size: 16px;
        display: flex;
        justify-content: center;
        align-items: self-start;
      }
    }
  }
}
</style>